import { makeStyles } from "@material-ui/core";

export const useVoucherLimitsStyles = makeStyles(
  {
    styledCardContent: {
      "& > div": {
        borderBottom: "1px solid #EAEAEA",
        padding: "0 24px"
      },
      padding: "0 0 12px !important"
    }
  },
  { name: "VoucherLimits_Styles" }
);

export const useCommonFieldStyles = makeStyles(
  {
    divContainerStyle: {
      "& > div": {
        paddingBottom: "12px !important"
      }
    },
    errorHelperTextStyle: {
      color: "#EC5D77",
      margin: "0 0 8px"
    }
  },
  { name: "VoucherLimits_CommonField_Styles" }
);
